import { FC, useRef } from "react";
import Label from "../label/label";
import { Field, useFormikContext } from "formik";
import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import SettingSelectField from "../settingFields/SettingSelectField";
import { validateItemName } from "@/utilities/Validation";
import { typeOptions } from "./install/install-oss-device/OssDropDownOptions";

const OssDetials: FC = () => {
    const { translate } = useLocale();
    const { values, errors } = useFormikContext<any>();
    const inputRef = useRef<HTMLInputElement>(null);

    return <>
        <div className="flex flex-row">
            <div className="flex flex-col flex-1 pr-3">
                <div className="flex flex-row justify-between" id='ossdTypeLabel'>
                    <Label
                        htmlFor="ossdType"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.type)}:</Label>
                    {errors.ossdType ? <span className='text-red-600 text-xs'>{errors.ossdType}</span> : null}
                </div>

                <div className="flex flex-row justify-between">
                    <SettingSelectField
                        className="flex flex-row w-full"
                        accessor={`ossdType`}
                        options={typeOptions} />
                </div>
            </div>

            <div className="flex flex-col flex-1 pr-3">
                <div className="flex flex-row justify-between" id='ossdDeviceLabel'>
                    <Label htmlFor='ossdDeviceId'
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(values.ossdType === "0" ? TranslationKeys.doorGroupId : TranslationKeys.doorId)}:</Label>
                    {errors.ossdDeviceId ? <span className='text-red-600 text-xs'>{errors.ossdDeviceId}</span> : null}
                </div>
                <div className="flex flex-row justify-between">
                    <Field
                        type="text"
                        name="ossdDeviceId"
                        data-cy="ossdDeviceField"
                        id="ossdDeviceInput"
                        innerRef={inputRef}
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                        validate={validateItemName} />
                </div>
            </div>
        </div>

    </>
}

export default OssDetials;